import gql from 'graphql-tag';

export const GET_SUPPLIERS = gql`
  query getSuppliers(
    $locationId: ID
    $search: String
    $pagination: PaginationAttributes
  ) {
    items: suppliers(
      locationId: $locationId
      search: $search
      pagination: $pagination
    ) {
      id
      name
      email
      address
      postalcode
      totalInventory
      amountProducts
    }
  }
`;
